// Supported ISO currency codes across the CRM. Keep in sync with the backend's
// src/constants/currencies.js — both lists must match.
export const SUPPORTED_CURRENCIES = [
  'INR', 'USD', 'EUR', 'GBP', 'AED', 'SAR', 'QAR', 'KWD', 'BHD', 'OMR', 'JOD',
  'AUD', 'CAD', 'NZD', 'SGD', 'HKD', 'CHF', 'JPY', 'CNY', 'KRW',
  'ZAR', 'NGN', 'KES', 'EGP', 'BRL', 'MXN', 'ARS',
  'IDR', 'MYR', 'THB', 'VND', 'PHP', 'PKR', 'BDT', 'LKR', 'NPR',
  'TRY', 'RUB', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'ILS',
];
